import React from "react";

import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable } from "../../services/visualLibraryService";
import { i18n, directions } from "../../services/i18nService";
import { getCurrentProfile, onEditProfile } from "../../services/multipleProfilesService";
import FreeLogo from "../../components/FreeLogo";
import { getSdk } from "../../services/sdkService";
import {
  PageWrapper,
  PageContentStyled,
  LogoStyled,
  TitleWithDescriptionStyled,
  TitleStyled,
  DescriptionStyled,
  CardsContainerStyled,
  CategoryCardStyled,
  CategoryCardHeaderStyled,
  RadioIconStyled,
  RadioLabelStyled,
  CategoryCardDescriptionStyled,
  SeparatorStyled,
  CheckboxContainerStyled,
  CheckboxStyled,
  CheckboxContentStyled,
  CheckboxTitleStyled,
  CheckboxDescriptionStyled,
  CategoryCardDivStyled,
  ButtonsWrapper,
  ButtonStyled
} from "./styles/Styled";
import { showSaveProfileChangesModal } from "../../utils/multiProfileModalUtils";
import { routes } from "../../routes/routes";
import { redirectTo } from "../../services/navigationService";
import { historyMethods } from "../../utils/historyMethods";
import { showMultipleProfileErrorModal } from "../../services/modalsService";
import { trackEvent } from "../../services/analyticsService";

const Button = withFocusable(ButtonStyled);
const CardsContainerStyledFocus = withFocusable(CardsContainerStyled);
const CheckboxStyledFocus = withFocusable(CheckboxStyled);

const defaultFocus = "section";
const saveFocus = "save_passThru";
const discardFocus = "discard_passThru";
const isFocused = "focused";
const saveChanges = "SAVE_CHANGES";
const discardChanges = "DISCARD_CHANGES";

class ViewingRestriction extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeCardIndex: null,
      focusedCardIndex: 0,
      currentValue: null,
      isKidsProfile: false,
      profileName: "",
      isUserChangeAnything: false
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
    this.selectCard = this.selectCard.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onDiscardChanges = this.onDiscardChanges.bind(this);
    this.doNothing = this.doNothing.bind(this);
    this.categoryCardsData = [
      {
        key: 0,
        value: "1",
        type: "KIDS",
        title: i18n.get("pages.settings.parentalControl.level.1"),
        description: i18n.get("pages.settings.parentalControl.description.1"),
        active: false
      },
      {
        key: 1,
        value: "7",
        type: "KIDS",
        title: i18n.get("pages.settings.parentalControl.level.7"),
        description: i18n.get("pages.settings.parentalControl.description.7"),
        active: false
      },
      {
        key: 2,
        value: "15",
        type: "ADULT",
        title: i18n.get("pages.settings.parentalControl.level.15"),
        description: i18n.get("pages.settings.parentalControl.description.15"),
        active: false
      },
      {
        key: 3,
        value: "18",
        type: "ADULT",
        title: i18n.get("pages.settings.parentalControl.level.18"),
        description: i18n.get("pages.settings.parentalControl.description.18"),
        active: false
      }
    ];
    this.isSaveChangesModalOpen = false;
  }

  handleKeyDown = async event => {
    const { focusedCardIndex, activeCardIndex } = this.state;
    const { applicationState } = this.props;
    const checkCurrentFocus = applicationState.currentFocus.split("-")[0];
    if (event.keyCode === 37) {
      if (checkCurrentFocus === saveChanges || checkCurrentFocus === discardChanges) return;
      //RTL right
      if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
        if (focusedCardIndex < this.categoryCardsData.length - 1 && focusedCardIndex !== -1) {
          if (checkCurrentFocus === saveFocus || checkCurrentFocus === discardFocus) return;
          this.setState({
            focusedCardIndex: focusedCardIndex + 1
          });
        }
      } else {
        //left
        if (focusedCardIndex > 0) {
          if (checkCurrentFocus === saveFocus || checkCurrentFocus === discardFocus) return;
          this.setState({
            focusedCardIndex: focusedCardIndex - 1
          });
        }
      }
    } else if (event.keyCode === 39) {
      if (checkCurrentFocus === saveChanges || checkCurrentFocus === discardChanges) return;
      //RTL left
      if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
        if (focusedCardIndex > 0) {
          if (checkCurrentFocus === saveFocus || checkCurrentFocus === discardFocus) return;
          this.setState({
            focusedCardIndex: focusedCardIndex - 1
          });
        }
      } else {
        //right
        if (focusedCardIndex < this.categoryCardsData.length - 1 && focusedCardIndex !== -1) {
          if (checkCurrentFocus === saveFocus || checkCurrentFocus === discardFocus) return;
          this.setState({
            focusedCardIndex: focusedCardIndex + 1
          });
        }
      }
    } else if (event.keyCode === 40) {
      if (checkCurrentFocus === saveChanges || checkCurrentFocus === discardChanges) return;
      //down arrow
      if (focusedCardIndex > -1) {
        this.setState(
          {
            focusedCardIndex: -1
          },
          () => {
            !this.state.isUserChangeAnything && this.state.isMasterProfile
              ? this.props.setFocus(discardFocus)
              : this.state.isMasterProfile && this.props.setFocus(saveFocus);
          }
        );
      } else if (focusedCardIndex === -1 && !this.state.isMasterProfile) {
        this.setState(
          {
            focusedCardIndex: -2
          },
          () => {
            !this.state.isUserChangeAnything ? this.props.setFocus(discardFocus) : this.props.setFocus(saveFocus);
          }
        );
      }
    } else if (event.keyCode === 38) {
      if (checkCurrentFocus === saveChanges || checkCurrentFocus === discardChanges) return;
      //up arrow
      if (focusedCardIndex === -2 && !this.state.isMasterProfile) {
        this.setState({
          focusedCardIndex: -1
        });
      } else if (focusedCardIndex === -1) {
        this.setState({
          focusedCardIndex: activeCardIndex
        });
      }
    } else if (event.keyCode === 13) {
      //ok
      if (checkCurrentFocus === saveFocus || checkCurrentFocus === discardFocus) return;
      focusedCardIndex > -1 && this.handleCategorySelect(focusedCardIndex);
      this.state.isMasterProfile ? this.doNothing() : focusedCardIndex === -1 && this.selectKidsAgeRestriction();

      const currentProfileData = await getCurrentProfile();
      const currentProfileCategory = this.state.isKidsProfile ? "KIDS" : "ADULT";
      const currentParentalControl = +this.state.currentValue;
      if (
        currentParentalControl !== currentProfileData.parentalControl ||
        currentProfileCategory !== currentProfileData.profileCategory
      ) {
        this.setState(
          {
            isUserChangeAnything: true,
            focusedCardIndex: this.state.isMasterProfile ? -1 : -2
          },
          () => {
            this.props.setFocus(saveFocus);
          }
        );
      }
      if (this.categoryCardsData[this.state.activeCardIndex].value === currentProfileData.parentalControl) {
        const parentalControlIndex = this.categoryCardsData.findIndex(function(item, i) {
          return item.value === currentProfileData.parentalControl;
        });
        this.setState(
          {
            isUserChangeAnything: false,
            focusedCardIndex: parentalControlIndex
          },
          () => {
            this.props.setFocus(defaultFocus);
          }
        );
      }
    } else if (event.keyCode === 461 || event.keyCode === 8) {
      //explict back
      this.props.setFocus(defaultFocus);
    }
  };

  doNothing() {}

  handleCategorySelect = index => {
    this.setState({
      activeCardIndex: index
      //  currentValue : this.categoryCardsData[index].value
    });
    if (this.state.isKidsProfile && index > 1) {
      this.setState({
        isKidsProfile: false
      });
    }
  };

  selectKidsAgeRestriction = () => {
    const { isKidsProfile } = this.state;
    this.setState({
      isKidsProfile: !isKidsProfile,
      activeCardIndex: 1
    });
  };

  clickOnKidsCheck = () => {
    const { isKidsProfile } = this.state;
    const currentProfileData = getCurrentProfile();
    const currentProfileCategory = this.state.isKidsProfile ? "KIDS" : "ADULT";
    const currentParentalControl = +this.state.currentValue;
    this.setState(
      {
        isKidsProfile: !isKidsProfile,
        activeCardIndex: 1,
        isUserChangeAnything:
          currentParentalControl !== currentProfileData.parentalControl ||
          currentProfileCategory !== currentProfileData.profileCategory
            ? true
            : false,
        focusedCardIndex: this.state.isMasterProfile ? -1 : -2
      },
      () => {
        this.props.setFocus(saveFocus);
      }
    );
  };

  async selectCard(index) {
    const { focusedCardIndex } = this.state;
    const { applicationState } = this.props;
    const checkCurrentFocus = applicationState.currentFocus.split("-")[0];

    if (checkCurrentFocus === saveFocus || checkCurrentFocus === discardFocus) return;
    index > -1 && this.handleCategorySelect(index);
    const currentProfileData = await getCurrentProfile();
    const currentProfileCategory = this.state.isKidsProfile ? "KIDS" : "ADULT";
    const currentParentalControl = +this.state.currentValue;
    if (
      currentParentalControl !== currentProfileData.parentalControl ||
      currentProfileCategory !== currentProfileData.profileCategory
    ) {
      this.setState(
        {
          isUserChangeAnything: true,
          focusedCardIndex: this.state.isMasterProfile ? -1 : -2
        },
        () => {
          this.props.setFocus(saveFocus);
        }
      );
    }
    if (this.categoryCardsData[index].value === currentProfileData.parentalControl) {
      this.setState(
        {
          isUserChangeAnything: false,
          focusedCardIndex: index
        },
        () => {
          this.props.setFocus(defaultFocus);
        }
      );
    }
  }

  async onSaveChanges() {
    const { location } = this.props;
    const profileCategoryInfo = this.state.isKidsProfile ? "KIDS" : "ADULT";
    this.setState(
      {
        currentValue: this.categoryCardsData[this.state.activeCardIndex].value
      },
      async () => {
        try {
          const updatedProfileData = await onEditProfile.call(this, {
            profileId: location.state.profileData.profileId,
            parentalControl: this.state.currentValue,
            profileCategory: this.state.isKidsProfile ? "KIDS" : "ADULT",
            isMasterProfile: location.state.profileData.isMasterProfile
          });
          const updatedProfile = {
            location: this.isSaveChangesModalOpen ? "back discard popup" : "manage profile screen",
            isParentalControlChange: !!(location.state.profileData.parentalControl !== this.state.currentValue),
            isProfileCategoryChange: !!(location.state.profileData.profileCategory !== profileCategoryInfo)
          };
          trackEvent("profile_settings_updated", null, "MP", {
            profileData: { updatedProfileId: updatedProfileData?.profileId, ...updatedProfileData },
            updatedProfile
          });
          const sdk = await getSdk();
          await sdk.mediaManager.clearLayoutCache();
          localStorage.setItem("parentalLevel", this.state.currentValue);
          this.isSaveChangesModalOpen = false;
          redirectTo.call(this, routes.settings, null, historyMethods.REPLACE);
        } catch (e) {
          showMultipleProfileErrorModal.call(this, saveFocus);
        }
      }
    );
  }

  backHandler() {
    this.setState({ focusedCardIndex: this.state.activeCardIndex });
    if (this.state.isUserChangeAnything) {
      this.isSaveChangesModalOpen = true;
      return showSaveProfileChangesModal.call(this, this.onSaveChanges, this.onDiscardChanges);
    } else {
      this.onDiscardChanges();
    }
  }

  onBack() {
    this.backHandler();
    return true;
  }

  onDiscardChanges() {
    const { stateActions, history } = this.props;
    const profileData = this.props.history.location.state.profileData;
    this.setState({}); // Reset state
    this.isSaveChangesModalOpen = false;
    trackEvent("profile_settings_update_discarded", null, "MP", { location: "back discard popup", ...profileData });
    stateActions.hideGlobalModal();
    history.replace({
      pathname: routes.settings
    });
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    this.props.setFocus(defaultFocus);
    const { onRef } = this.props;
    onRef && onRef(this);
    const { location } = this.props;
    const hasLocationState = !!(location && location.state);
    const profileData = location?.state?.profileData;
    if (profileData) {
      const parentalControlIndex = this.categoryCardsData.findIndex(function(item, i) {
        return item.value === profileData.parentalControl;
      });
      hasLocationState &&
        profileData &&
        this.setState({
          profileName: profileData.profileName,
          currentValue: profileData.parentalControl,
          isKidsProfile: profileData.profileCategory === "KIDS",
          activeCardIndex: parentalControlIndex,
          focusedCardIndex: parentalControlIndex,
          isMasterProfile: profileData.isMasterProfile
        });
      trackEvent("view_profile_restrictions", null, "MP", profileData);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render() {
    const { activeCardIndex, focusedCardIndex, isKidsProfile, profileName, currentValue } = this.state;
    return (
      <PageWrapper direction={i18n.getDirection()}>
        <LogoStyled direction={i18n.getDirection()}>
          <FreeLogo height={"1.968rem"} />
        </LogoStyled>
        <PageContentStyled>
          <TitleWithDescriptionStyled>
            <TitleStyled> {i18n.get("pages.settings.parentalControl.restrictionPageHeading")}</TitleStyled>
            <DescriptionStyled>
              {i18n.get("pages.settings.parentalControl.restrictionHeading", profileName)}{" "}
              {i18n.get(`pages.settings.parentalControl.description.${currentValue}`)}
            </DescriptionStyled>
          </TitleWithDescriptionStyled>
          <CardsContainerStyledFocus direction={i18n.getDirection()}>
            {this.categoryCardsData.map((item, index) => (
              <div>
                <CategoryCardDivStyled></CategoryCardDivStyled>
                <CategoryCardStyled
                  isFocused={index === focusedCardIndex}
                  isActive={index === activeCardIndex}
                  direction={i18n.getDirection()}
                  onMouseUp={event => this.selectCard(index, event.target)}
                >
                  <CategoryCardHeaderStyled>
                    <RadioIconStyled isFocused={index === focusedCardIndex} isActive={index === activeCardIndex} />
                    <RadioLabelStyled direction={i18n.getDirection()}>{item.title}</RadioLabelStyled>
                  </CategoryCardHeaderStyled>
                  <CategoryCardDescriptionStyled direction={i18n.getDirection()}>
                    {item.description}
                  </CategoryCardDescriptionStyled>
                </CategoryCardStyled>
              </div>
            ))}
          </CardsContainerStyledFocus>
          {!this.state.isMasterProfile && (
            <>
              <SeparatorStyled />
              <CheckboxContainerStyled>
                <CheckboxStyledFocus
                  type="checkbox"
                  checked={isKidsProfile}
                  className={focusedCardIndex === -1 && isFocused}
                  onChange={this.selectKidsAgeRestriction}
                  onMouseUp={() => this.clickOnKidsCheck()}
                  direction={i18n.getDirection()}
                  width="4rem"
                  height="4rem"
                  focussedBorderColor="primary"
                />
                <CheckboxContentStyled>
                  <CheckboxTitleStyled>
                    {i18n.get("pages.settings.parentalControl.kidsProfileHeading")}
                  </CheckboxTitleStyled>
                  <CheckboxDescriptionStyled>
                    {i18n.get("pages.settings.parentalControl.kidsProfileDescription")}
                  </CheckboxDescriptionStyled>
                </CheckboxContentStyled>
              </CheckboxContainerStyled>
              <SeparatorStyled />
            </>
          )}
        </PageContentStyled>
        <ButtonsWrapper>
          <Button
            label={i18n.get("global.save").toUpperCase()}
            focusPath={saveFocus}
            onEnterPress={this.onSaveChanges}
            onMouseUp={this.onSaveChanges}
            size="small"
            spacing="small"
            displayBlock={true}
            direction={i18n.getDirection()}
            operation={"save"}
            disabled={!this.state.isUserChangeAnything}
          />
          <Button
            label={i18n.get("global.cancel").toUpperCase()}
            focusPath={discardFocus}
            onEnterPress={this.backHandler}
            onMouseUp={this.backHandler}
            dataSnLeft={!this.state.isUserChangeAnything ? "" : null}
            size="small"
            spacing="small"
            operation={"cancel"}
            direction={i18n.getDirection()}
            displayBlock={true}
          />
        </ButtonsWrapper>
      </PageWrapper>
    );
  }
}

const Component = withAppState(withSubtheme(ViewingRestriction));
Component.defaultFocusPath = defaultFocus;
export default Component;
